// src/store/authSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  authData: null,

};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuthData: (state, action) => {
      state.authData = action.payload
    },
    setRememberMe: (state, action) => {
      state.rememberMe = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    resetAuthState: () => initialState
  },
});

// Export actions
export const {
   setAuthData,
   setRememberMe,
   setLoading,
   setError,
   resetAuthState
   } = authSlice.actions;

// Export reducer
export default authSlice.reducer;
